import { render, staticRenderFns } from "./AddPrescriptionNew.vue?vue&type=template&id=7be4d836"
import script from "./AddPrescriptionNew.vue?vue&type=script&lang=js"
export * from "./AddPrescriptionNew.vue?vue&type=script&lang=js"
import style0 from "./AddPrescriptionNew.vue?vue&type=style&index=0&id=7be4d836&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports